module.exports = __webpack_public_path__ + "img/073414.6d9b509f.png";